"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DateRangePickerInput;

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _reactBootstrapDaterangepicker = _interopRequireDefault(require("react-bootstrap-daterangepicker"));

var _CalendarWithModal = _interopRequireDefault(require("./CalendarWithModal"));

var _helpers = require("./helpers");

require("bootstrap-daterangepicker/daterangepicker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

DateRangePickerInput.defaultProps = {
  initialOn: false,
  toggleModal: null,
  inputProps: {},
  initialStartDate: null,
  initialEndDate: null,
  isInvalidDate: null,
  minDate: new Date(),
  onApply: function onApply() {},
  boostrapDateRangePickerProps: {},
  inputDateFormat: 'DD MMM YYYY',
  showInputText: function showInputText(startDate, endDate, format) {
    return (0, _helpers.getFormattedDate)(startDate, endDate, format);
  }
};
var hundredWidth = {
  width: '100%'
};

function DateRangePickerInput(props) {
  var showInputText = props.showInputText,
      initialOn = props.initialOn,
      toggleModal = props.toggleModal,
      inputProps = props.inputProps,
      minDate = props.minDate,
      _onApply = props.onApply,
      boostrapDateRangePickerProps = props.boostrapDateRangePickerProps,
      initialStartDate = props.initialStartDate,
      initialEndDate = props.initialEndDate,
      inputDateFormat = props.inputDateFormat,
      isInvalidDate = props.isInvalidDate,
      rest = _objectWithoutProperties(props, ["showInputText", "initialOn", "toggleModal", "inputProps", "minDate", "onApply", "boostrapDateRangePickerProps", "initialStartDate", "initialEndDate", "inputDateFormat", "isInvalidDate"]);

  var _React$useState = _react["default"].useState(initialOn),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      on = _React$useState2[0],
      setIsOn = _React$useState2[1];

  var toggle = function toggle() {
    return setIsOn(!on);
  };

  var startDateAndEndDateAsInputText = initialStartDate && initialEndDate ? showInputText(initialStartDate, initialEndDate, inputDateFormat) : '';

  if (boostrapDateRangePickerProps && boostrapDateRangePickerProps.singleDatePicker) {
    var format = (0, _helpers.formatDate)(inputDateFormat);
    return _react["default"].createElement(_reactBootstrapDaterangepicker["default"], _extends({
      onApply: function onApply(e, _ref) {
        var startDate = _ref.startDate;
        return _onApply(startDate);
      },
      minDate: minDate,
      singleDatePicker: true,
      autoApply: true,
      endDate: "",
      isInvalidDate: isInvalidDate
    }, boostrapDateRangePickerProps), _react["default"].createElement(_reactstrap.Input, _extends({
      value: initialStartDate ? format(initialStartDate) : null,
      readOnly: true
    }, inputProps)));
  }

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "d-block d-sm-none",
    style: hundredWidth
  }, _react["default"].createElement(_reactstrap.Input, _extends({
    value: startDateAndEndDateAsInputText,
    readOnly: true,
    onClick: toggle
  }, inputProps)), _react["default"].createElement(_CalendarWithModal["default"], _extends({
    isModalOpen: on,
    toggleModal: toggleModal || toggle,
    onApply: _onApply,
    initialStartDate: initialStartDate,
    initialEndDate: initialEndDate,
    isInvalidDate: isInvalidDate
  }, rest))), _react["default"].createElement("div", {
    className: "d-none d-sm-block",
    style: hundredWidth
  }, _react["default"].createElement(_reactBootstrapDaterangepicker["default"], _extends({
    onApply: function onApply(e, _ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      return _onApply(startDate, endDate);
    },
    minDate: minDate,
    autoApply: true,
    isInvalidDate: isInvalidDate
  }, boostrapDateRangePickerProps), _react["default"].createElement(_reactstrap.Input, _extends({
    value: startDateAndEndDateAsInputText,
    readOnly: true
  }, inputProps)))));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@honeyguide/components/dist/components/DateRangePicker/DateRangePickerInput.js
// module id = 2128
// module chunks = 2